import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="planes" className="w-full bg-white py-16 md:py-24" data-id="element-154" data-mp="2jlyvnpqj53jz">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-155" data-mp="1vujy0a9p7af2">
        {showUrgency && <CountdownPanel data-id="element-156" data-mp="1rthvnkkhii8v" />}

        <h2 className="mt-16 text-center font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-157" data-mp="1ru9lsfvbbnrr">
          Tu inversión en el <span className="text-blue-600" data-id="element-158" data-mp="20sv90obqbqyv">Atlas Kinesio-Visual</span>
        </h2>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-white p-7 shadow-lift ring-2 ring-blue-600 md:p-10" data-id="element-159" data-mp="3h74o0ru303d1">
          <p className="text-center font-display text-xl font-extrabold uppercase tracking-tight text-ink md:text-2xl" data-id="element-160" data-mp="3c93301d3htyx">
            {offer.name}
          </p>
          <p className="mt-2 text-center text-lg text-blue-900/75" data-id="element-161" data-mp="3w1t5xq09ir4j">{offer.summary}</p>

          <ul className="mx-auto mt-8 grid max-w-xl gap-4 text-left sm:grid-cols-2" data-id="element-162" data-mp="4v8kqmww2dff">
            {offer.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-163" data-mp="er1uxzn4xuu1">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint-50 text-mint-600" data-id="element-164" data-mp="ep8xnayewmyp">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="3i7sfrkndmcfs" />
                </span>
                <span className="text-ink" data-id="element-166" data-mp="3n75120ylnbg9">{item}</span>
              </li>)}
          </ul>

          <div className="mt-10 text-center" data-id="element-167" data-mp="3rxlhzv1mpf7d">
            <p className="text-lg text-blue-900/45" data-id="element-168" data-mp="3rzep1bg5m1fw">
              Valor real <span className="line-through" data-id="element-169" data-mp="2uizjfn2ue2kn">{offer.listPrice}</span>
            </p>
            <p className="font-display text-5xl font-extrabold tracking-tight text-ink md:text-6xl" data-id="element-170" data-mp="2zharbs9ku308">
              {offer.price}
              <span className="ml-2 text-xl font-semibold text-blue-900/55" data-id="element-171" data-mp="2rftd4cbb7lg6">ARS</span>
            </p>
            <p className="mt-3 inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm font-bold text-mint-600" data-id="element-172" data-mp="2mgqkjrcin7p3">
              <span className="rounded-lg bg-mint-50 px-3 py-1 uppercase tracking-wide" data-id="element-173" data-mp="315wilbzmarve">
                {offer.discount}
              </span>
              <span className="text-blue-900/70" data-id="element-174" data-mp="28hh1mjwxdzhf">Ahorrás {offer.savings}</span>
            </p>
          </div>

          <div className="mt-8" data-id="element-175" data-mp="23jpc1wjr6pge">
            <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-176" data-mp="23kgz2izabev2">
              {offer.cta}
            </CtaButton>
          </div>

          <p className="mt-4 text-center text-sm text-blue-900/60" data-id="element-177" data-mp="2dh3gsywbdpsv">
            Acceso inmediato | 100% digital | Garantía 7 días
          </p>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-178" data-mp="3ttsa82abxtlb">
          <li className="inline-flex items-center gap-2" data-id="element-179" data-mp="3oyla14g9r715">
            <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-180" data-mp="9m1gdyu7m93" /> Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-181" data-mp="5b1m44x3rqqy">
            <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-182" data-mp="3nflb8egzbofz" /> Descarga en 2 minutos
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-183" data-mp="3rfwwnth61ssi">
            <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-184" data-mp="3rihxcf5qa2oo" /> Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-185" data-mp="nzopmizms82f">
            <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-186" data-mp="nz6kewuzqjid" /> Mercado Pago |
            Transferencia
          </li>
        </ul>
      </div>
    </section>;
}